<template>
  <span :class="statusClass" class="px-2 py-1 text-xs font-medium rounded-full">
    {{ statusText }}
  </span>
</template>

<script>
export default {
  name: 'OrderStatus',
  
  props: {
    status: {
      type: String,
      required: true
    }
  },

  computed: {
    statusClass() {
      const classes = {
        pending: 'bg-yellow-100 text-yellow-800',
        request: 'bg-yellow-100 text-yellow-800',
        finish: 'bg-green-100 text-green-800',
        processing: 'bg-blue-100 text-blue-800',
        completed: 'bg-green-100 text-green-800',
        cancelled: 'bg-red-100 text-red-800'
      }
      return classes[this.status] || 'bg-gray-100 text-gray-800'
    },

    statusText() {
      const texts = {
        request: 'Pendiente por pago',
        finish: 'Finalizada',
        pending: 'Pendiente',
        processing: 'En proceso',
        completed: 'Completado', 
        cancelled: 'Cancelado'
      }
      return texts[this.status] || this.status
    }
  }
}
</script>
